"use client";

import { IUserMilestone } from "@faire/web-api--source/indigofair/data/IUserMilestone";

import {
  useMilestone,
  useMilestoneByDate,
  useRecordMilestoneOnce,
} from "./useMilestoneBase";

/**
 * Hook used to get/set the value of a brand milestone for a user.
 */
export const useBrandMilestone = (
  milestoneType: IUserMilestone.BrandMilestone
): ReturnType<typeof useMilestone<IUserMilestone.BrandMilestone>> => {
  return useMilestone(true, milestoneType);
};

/**
 * Hook that returns a function to record a brand milestone at most once per day.
 * If the milestone has been recorded less than a day (24 hours) ago, the function will not record it again.
 */
export const useBrandMilestoneByDate = (
  milestoneType: IUserMilestone.BrandMilestone
): ReturnType<typeof useMilestoneByDate<IUserMilestone.BrandMilestone>> => {
  return useMilestoneByDate(true, milestoneType);
};

/**
 * Hook that returns a function to record a brand milestone at most once.
 * If the milestone has already been recorded, the function will not record it again.
 */
export const useBrandRecordMilestoneOnce = (
  milestoneType: IUserMilestone.BrandMilestone
): ReturnType<typeof useRecordMilestoneOnce<IUserMilestone.BrandMilestone>> => {
  return useRecordMilestoneOnce(true, milestoneType);
};
